import { render, staticRenderFns } from "./NodePopupVideo.vue?vue&type=template&id=1507131c"
import script from "./NodePopupVideo.vue?vue&type=script&lang=js"
export * from "./NodePopupVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports